import * as materials from "materials/legacy/legacy-terrain";
export { materials };
export default materials;
